import React from 'react';

import { ButtonsWrapper, Button } from './styles';

const InlineButtonsGroup = ({ items, ...props }) => (
  <ButtonsWrapper gridTemplateColumns={`repeat(${items.length}, 1fr)`} {...props} >
    {items.map((item, id) => (
      <Button
        key={`inline-button-${id}`}
        data-value={item.dataValue || ''}
        selected={item.selected}
        onClick={item.onClick}
        {...props}
      >
        {item.text || item.icon}
      </Button>
    ))}
  </ButtonsWrapper>
);

export default React.memo(InlineButtonsGroup);
